import {A} from "@solidjs/router"
import css from "./header.module.css"
import Container from "~/components/Container"
import MemberNav from "./layout/MemberNav"
import {LinkButton} from "./ui/Button"

export default function Header() {
    return (
        <header class={css.header}>
            <Nav/>
        </header>
    )
}

function Nav() {
    return (
        <nav class={css.nav}>
            <Container>
                <div class={css.innerNav}>
                    <A class={css.branding} href="/" aria-label="Graceful Space Yoga - Home Page">
                        <div class={css.logo}>
                            <img src="/logo.webp" alt="logo" width="1024" height="1024"/>
                        </div>
                        <span class={css.name}>Graceful Space Yoga</span>
                    </A>

                    <div class={css.links}>
                        <MemberNav/>
                        <LinkButton href="/classes" variant="primarySolid">Book Now</LinkButton>
                    </div>
                </div>
            </Container>
        </nav>
    )
}